import {Injectable, signal} from '@angular/core';

@Injectable({providedIn: 'root'})
export class BalanceVisibilityService {
  // Shared with the lb2 clients when they run on the same origin.
  private readonly storageKey = 'lb2.balanceHidden';
  private readonly hiddenState = signal(false);
  readonly hidden = this.hiddenState.asReadonly();

  constructor() {
    try {
      this.hiddenState.set(localStorage.getItem(this.storageKey) === 'true');
    } catch {
      // The toggle still works for this session when browser storage is unavailable.
    }
  }

  toggle(): void {
    this.hiddenState.update(hidden => !hidden);
    try {
      localStorage.setItem(this.storageKey, String(this.hidden()));
    } catch {
      // Keep the selected visibility even if the browser cannot save it.
    }
  }
}
